var acceptableDocumentationTileJS = (function() {
    return {
        initialized: false,
        init: function() {
            if (this.initialized) {
                return;
            }

            $(window).on('resize', function() {
                if(window.innerWidth > 1199.98) {
                    $(".faq-forms-docs-overlay").css('display', '');
                    $(".faq-forms-docs-mobile-button-container").css('display', '');
                    $("body").removeClass("faq-forms-docs-overlay-freeze");
                    $(".faq-forms-docs-mobile-search-container").css("display", "");
                } else {
                    toggleScroll();
                }
            });

            /*User Search*/
            const container = $(".acceptable-documentation-tile-container");
            const userInput = $(".acceptable-documentation-search-field");

            //Filter Through Search
            userInput.keyup(function () {
                const word = this.value;

                //Sync the 2 search fields
                $(".acceptable-documentation-search-field").val(word);

                //Shows/hides questions and answers
                for (let i = 0; i < container.length; i++) {
                    const titleElem = $(container[i]).children('.acceptable-documentation-tile-title');
                    const contentElem = $(container[i]).children('.acceptable-documentation-tile-content');

                    const title = $(titleElem).text().trim().toLowerCase();
                    const content = $(contentElem).text().trim().toLowerCase();

                    if (!title.includes(word) && !content.includes(word)) {
                        $(titleElem).addClass('d-none');
                        $(contentElem).addClass('d-none');
                        //Hides Read More/Less
                        if(content.length > 510 || $(contentElem).data("li-count") > 3) {
                            $(contentElem).siblings('.acceptable-documentation-read-more').addClass('d-none');
                            $(contentElem).siblings('.acceptable-documentation-read-less').addClass('d-none');
                        }
                    } else {
                        $(titleElem).removeClass('d-none');
                        $(contentElem).removeClass('d-none');

                        if(content.length > 510 || $(contentElem).data("li-count") > 3) {
                            $(contentElem).siblings('.acceptable-documentation-read-less').trigger('click');
                        }
                    }
                }
            });

            $('.acceptable-documentation-read-more').click(function() {
                $(this).addClass('d-none');
                $(this).siblings('.acceptable-documentation-read-less').removeClass('d-none');
                $(this).prev().addClass('acceptable-documentation-line-clamp-unset');
            });

            $('.acceptable-documentation-read-less').click(function() {
                $(this).addClass('d-none');
                $(this).siblings('.acceptable-documentation-read-more').removeClass('d-none');
                $(this).prev().prev().removeClass('acceptable-documentation-line-clamp-unset');
            });

            $('.faq-forms-docs-mobile-filter-button').click(function() {
                $(".faq-forms-docs-overlay").css("display", "block");
                $("body").addClass("faq-forms-docs-overlay-freeze");

                toggleScroll();
            });

            $('.faq-forms-docs-overlay-close-button').click(function() {
                $(".faq-forms-docs-overlay").css("display", "");
                $(".faq-forms-docs-mobile-filter-button").css("display", "");
                $("body").removeClass("faq-forms-docs-overlay-freeze");
            });

            $('.faq-forms-docs-overlay-list-item').click(function() {
                const target = $(this).data('scroll-target');
                $("body").removeClass("faq-forms-docs-overlay-freeze");

                $('html, body').animate({
                    scrollTop: $('#'+ target).offset().top - 70
                });
                $('.faq-forms-docs-overlay-close-button').trigger('click');
            });

            $('.faq-forms-docs-mobile-search-button').click(function() {
                $(".faq-forms-docs-mobile-button-container").css("display", "none");
                $(".faq-forms-docs-mobile-search-container").css("display", "flex");
                $(".main-page-header").parent().css("margin-top", "80px");

                $(".faq-forms-docs-mobile-search-container").find('.faq-forms-docs-search-field').focus();
            });

            $('.faq-forms-docs-mobile-search-close').click(function() {
                $(".faq-forms-docs-mobile-button-container").css("display", "");
                $(".faq-forms-docs-mobile-search-container").css("display", "");
                $(".main-page-header").parent().css("margin-top", "");
            });

            //If there are too many items, make it scrollable
            function toggleScroll() {
                const list = $('.faq-forms-docs-overlay-list');
                const scrollHeight = list[0].scrollHeight;
                const clientHeight = list[0].clientHeight;

                if(scrollHeight > clientHeight) {
                    list.css("justify-content", "flex-start");
                    list.css("overflow", "auto");
                } else {
                    list.css("justify-content", "");
                    list.css("overflow", "");
                }
            }
        }
    }
})();

